import { apiRequest, patchJson, postJson } from "./api";
import { API_BASE } from "../config/api";

export const getAdminStats = () => apiRequest("/api/admin/stats");

export const getMembers = (search = "") =>
  apiRequest(`/api/admin/members?search=${encodeURIComponent(search)}`);

export const getPendingMembers = () => apiRequest("/api/admin/pending-members");

export const getCareerApplications = ({ search = "", domain = "", status = "" } = {}) =>
  apiRequest(
    `/api/admin/careers?search=${encodeURIComponent(search)}&domain=${encodeURIComponent(domain)}&status=${encodeURIComponent(status)}`
  );

export const updateCareerApplicationStatus = (applicationId, status) =>
  patchJson(`/api/admin/careers/${applicationId}/status`, { status });

export const getMemberAttendance = (memberId) =>
  apiRequest(`/api/admin/members/${memberId}/attendance`);

export const approveMember = (membershipId) =>
  patchJson(`/api/admin/approve/${membershipId}`);

export const rejectMember = (membershipId) =>
  patchJson(`/api/admin/reject/${membershipId}`);

export const deleteMember = (membershipId) =>
  apiRequest(`/api/admin/members/${membershipId}`, { method: "DELETE" });

export const createEvent = (payload) => postJson("/api/events", payload);

export const updateEvent = (eventId, payload) =>
  patchJson(`/api/events/${eventId}`, payload);

export const uploadEventPoster = async (file) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE}/api/admin/upload-poster`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const contentType = response.headers.get("content-type") || "";
  let data;

  if (contentType.includes("application/json")) {
    data = await response.json();
  } else {
    const text = await response.text();
    throw new Error(`Upload error: ${text || "Unknown error"}`);
  }

  if (!response.ok) {
    throw new Error(data.message || "Upload failed");
  }

  return data;
};

export const startAttendance = (eventId) =>
  postJson(`/api/events/${eventId}/start-attendance`, {});

export const deleteEvent = async (eventId) =>
  apiRequest(`/api/events/${eventId}`, { method: "DELETE" });

export const getEventAttendanceSummary = (eventId) =>
  apiRequest(`/api/events/${eventId}/attendance-summary`);
